import React from "react";

import { useHistory } from "react-router-dom";

import { EligibleScreen } from "../../EligibilityCheckerGeneric/ResultScreens";
import { PostcodeCheckerData } from "./PostcodeChecker";

interface PostcodeEligibleScreenProps {
  postcodePageData: PostcodeCheckerData;
  nextStepUrl: string;
}

const PostcodeEligibleScreen: React.FC<PostcodeEligibleScreenProps> = ({ postcodePageData, nextStepUrl }) => {
  const history = useHistory();

  return (
    <EligibleScreen
      title={postcodePageData.successScreen.title}
      heading={postcodePageData.successScreen.heading}
      bodyText={postcodePageData.successScreen.body}
      goToNextFunc={() => {
        history.push(nextStepUrl);
      }}
    />
  );
};

export default PostcodeEligibleScreen;
